// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:30:03

export default {
  "id": "farmer-rush-idle-farm-game",
  "slug": "farmer-rush-idle-farm-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a57ef0ff6ec44d9889500893ba619b56-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a57ef0ff6ec44d9889500893ba619b56/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Farmer Rush: Idle Farm Game",
      "description": "The combination of merging crops, upgrading your farm, and the satisfaction of watching your fields bloom makes this game a perfect pick for players who love farming sims or idle games.",
      "instructions": "Get ready to immerse yourself in a vibrant world where you can plant, merge, and harvest your way through beautifully designed farm fields. Start with a small plot of land and a handful of seeds. Your mission is to cultivate your farm into a flourishing paradise filled with a rich variety of crops. As you progress, you’ll unlock new areas, discover rare seeds, and develop your farming strategies to optimize your yields. Begin your journey to becoming a farming master!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "3d",
        "farm",
        "idle"
      ]
    },
    "zh-CN": {
      "title": "农夫冲刺：休闲农场游戏",
      "description": "合并作物、升级农场以及观看田地绽放的满足感，使这款游戏成为喜爱农场模拟或休闲游戏的玩家的完美选择。",
      "instructions": "准备好沉浸在充满活力的世界中，在这里你可以种植、合并和收割，穿梭于设计精美的农场田野。从一小块土地和一些种子开始。你的任务是把你农场培养成一个充满丰富农作物种类的人工天堂。随着你不断进步，你将解锁新区域，发现稀有种子，并发展你的农业策略以优化产量。开始你的旅程，成为农业大师吧！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "3D",
        "农场",
        "休闲"
      ]
    },
    "zh-TW": {
      "title": "農夫衝刺：閒置農場遊戲",
      "description": "結合種植作物、升級農場以及欣賞田地盛開的滿足感，讓這款遊戲成為喜愛農場模擬遊戲或無聊遊戲玩家的完美選擇。",
      "instructions": "準備好沉浸在一個充滿活力的世界中，你可以在精心設計的農田裡種植、合併和收穫。從一小塊土地和一握種子開始。你的任務是將你的農場培育成繁榮的樂園，充滿豐富多樣的作物。隨著你的進步，你將解鎖新區域，發現珍稀種子，並發展你的農業策略以優化收穫。開始你的旅程，成為農業大師！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "3D",
        "农場",
        "休閒"
      ]
    },
    "zh-HK": {
      "title": "農夫衝刺：閒置農場遊戲",
      "description": "種植作物、升級農場以及欣賞田地綻放帶來的滿足感，讓這款遊戲成為喜愛農場模擬遊戲或閒置遊戲玩家的完美選擇。",
      "instructions": "準備好投入於一個生機勃勃的世界，您可以種植、合併和收穫，穿越美麗設計的農田。從一塊小塊土地和一撮種子開始。您的使命是將您的農場培育成充滿多種農作物盛開的樂園。隨著進展，您將解鎖新區域，發現稀有種子，並發展您的農業策略以優化收穫。開始您的旅程，成為農業大師吧！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "3D",
        "農場",
        "休閒"
      ]
    },
    "ja": {
      "title": "ファーマー・ラッシュ：アイドル・ファーム・ゲーム",
      "description": "作物の統合、農場のレベルアップ、そして畑が咲くのを見る喜びが、農場シミュレーションやアイドルゲームを好むプレイヤーにとって完璧なゲームを選ぶのに最適な要素を提供します。",
      "instructions": "パワフルな世界に身を投じる準備をしてください。植える、合体させて、収穫する、そんな美しくデザインされた農場で農業を楽しむことができます。小さな土地と少しの種から始め、自分の農場を豊富な作物で満ちた繁栄する楽園に育ててください。進むにつれて、新しいエリアを解鎖し、珍しい種を発見し、収穫を最大化する農業戦略を発展させます。農業の達人への旅を始めましょう！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "農場",
        "アイドル"
      ]
    },
    "ko": {
      "title": "농부 러시: 아이들 페어밍 게임",
      "description": "농작물을 병합하고 농장을 업그레이드하며 시장이 피어나는 것을 보는 만족감이, 농업 시뮬레이션 게임이나 비アク티브 게임을 사랑하는 플레이어들에게 이 게임을 완벽한 선택으로 만듭니다.",
      "instructions": "빛나는 세상에 몸을 담아서 농장을 키우고, 합치고, 수확하는 농장을 통해 아름다운 디자인의 농장 필드를 탐험하세요. 작은 땅 한 구획과 일부 씨앗으로 시작하세요. 당신의 임무는 다양한 작물로 가득한 번영하는 농장을 만들어보세요. 진행하면서 새로운 구역을 해금하고, 드문 씨앗을 발견하고, 수확량을 최적화하기 위한 농사 지도 전략을 개발하세요. 농사 마스터가 되기 위해 여정을 시작하세요!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "농장,Idle"
      ]
    },
    "fr": {
      "title": "Farmer Rush : Jeu de Ferme Idle",
      "description": "La combinaison de la fusion des cultures, de la mise à niveau de votre ferme et de la satisfaction de voir vos champs fleurir rend ce jeu une choix parfait pour les joueurs qui aiment les simulations de ferme ou les jeux idle.",
      "instructions": "Préparez-vous à vous immerger dans un monde vibrant où vous pouvez planter, fusionner et récolter votre chemin à travers des champs de ferme magnifiquement conçus. Commencez avec une petite parcelle de terre et un tas de graines. Votre mission est de transformer votre ferme en un paradis fleuri rempli d'une riche variété de cultures. Au fur et à mesure de votre progression, vous déverrouillerez de nouvelles zones, découvrirez des graines rares et développerez vos stratégies agricoles pour optimiser vos rendements. Commencez votre voyage pour devenir un maître de l'agriculture !",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "ferme",
        "idle"
      ]
    }
  }
};
